import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles({
    topWrapper: {
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
        marginBottom: 16,
    },
    topWrapperTitle: {
        fontSize: 24,
        fontWeight: 600,
        color: "#fff",
        margin: 0,
    },
    headerWrapper: {
        display: "grid",
        alignItems: "center",
        gridTemplateColumns: "1fr 1fr 2fr 20%",
        gridColumnGap: "8px",
        border: "1px solid #FFFFFF4D",
        background: "#F5F5F50D",
        padding: 8,
        borderRadius: 12,
        transition: "ease-out 0.5s all",
        "&.prolimit": {
            gridTemplateColumns: "1fr 1fr 1fr 20%",
            transition: "ease-in 0.5s all",
        },
        "&.isFreePlay": {
            gridTemplateColumns: "1fr 1fr 1fr 20%",
            transition: "ease-in 0.5s all",
        }
    },

    typeRoundUnited: {
        display: "grid",
        alignItems: "center",
        gridTemplateColumns: "minmax(0%, 50%) 1fr",
        transition: "ease-out 0.5s all",
        gridGap: "8px",
        "&.prolimit": {
            gridTemplateColumns: "minmax(0%, 0%) 1fr",
            transition: "ease-in 0.5s all",
            gridGap: "0px",
        },
        "&.isFreePlay": {
            gridTemplateColumns: "minmax(0%, 100%) 1fr",
            transition: "ease-in 0.5s all",
            gridGap: "0px",
        },
    },

    createButton: {
        width: "100%",
        height: "100%",
    },

    disabledButton: {
        "&[disabled]": {
            backgroundColor: "#cccccc !important",
            color: "#666666 !important",
            cursor: "not-allowed !important",           
        },
    },
});
